import { useMemo } from 'react';

import { useAppSelector } from '@hooks/redux';
import { selected } from '@modules/organisation/selectors/organisation';

import type { CustomUserProperty } from '../types';
import { useOrganisationUserPropertyPredicateFilters } from './use-organisation-user-property-predicate-filters';

export function useCustomUserPropertiesForAudience(
  providedProperties?: CustomUserProperty[]
) {
  const organisation = useAppSelector(selected);
  const hasProvidedProperties = !!providedProperties?.length;

  const { properties } = useOrganisationUserPropertyPredicateFilters(
    organisation?.id,
    !hasProvidedProperties
  );

  return useMemo(
    () => (hasProvidedProperties ? providedProperties : properties),
    [hasProvidedProperties, providedProperties, properties]
  );
}
